export default "__VITE_ASSET__a18b9510__"